import { useEffect } from "react";
import { getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";
import { apiGetConstellations, apiGetBackups, apiGetDashboards } from "../../messages/api/gcmAPICallers";
import {
    apiGetUserManagement,
    apiGetUserGroups,
    apiGetUserGroup,
    apiGetUsers,
    apiGetUser,
} from "../../messages/api/gcmUserManagement";
import { IConstellationInfo, KeycloakUser, UserfulGroup } from "../../model/CarbonExternalModels";
import { IAppView } from "../../store/app/appUtils";
import {
    useCarbonDispatch,
    useCarbonSelector,
    selectAppView,
    selectConstellations,
    selectClusterRemoteManagements,
    selectUsers,
    selectUserGroups,
} from "../../store/carbonStore";
import AppStatus from "../app/AppStatus";
import BackupAndRestoreTable from "../backupAndRestore/BackupAndRestoreTable";
import ClusterPage from "../clusters/cluster/ClusterPage";
import ClustersTable from "../clusters/table/ClustersTable";
import ConstellationsTable from "../constellations/ConstellationsTable";
import DevicePage from "../devices/device/DevicePage";
import UserGroupPage from "../userGroups/UserGroupPage";
import UserGroupsTable from "../userGroups/UserGroupsTable";
import UserPage from "../users/UserPage";
import UsersTable from "../users/UsersTable";
import "./Contents.scss";
import { useMount } from "react-use";
import { GcmUserPermission } from "userful-chronos-app-common-js/dist/models/gcm-user-permission";

interface IProps {
    permissions: GcmUserPermission;
    show: boolean;
}

export default function Contents(props: IProps) {
    const dispatch = useCarbonDispatch();

    const appView: IAppView = useCarbonSelector(selectAppView);
    const constellations = useCarbonSelector(selectConstellations);
    const clusterRemoteManagements = useCarbonSelector(selectClusterRemoteManagements);
    const users = useCarbonSelector(selectUsers);
    const userGroups = useCarbonSelector(selectUserGroups);

    // TODO: coding issue - we need type safe objects here!

    let user = null;
    let group = null;
    let device = null;
    let cluster = null;
    let constellation;

    if (appView.type === "CONSTELLATION") {
        constellation = constellations[appView.id.value];
    }

    if (appView.type === "CLUSTER") {
        let foundConstellation;
        let foundCluster;

        for (const property in constellations) {
            const constellation = constellations[property];

            const cluster = constellation.cluster.find((c) => c.id.value === appView.id.value);

            if (cluster) {
                foundCluster = cluster;
                foundConstellation = constellation;
                break;
            }
        }

        if (foundCluster && foundConstellation) {
            cluster = { cluster: foundCluster, constellation: foundConstellation };
        }
    }

    if (appView.type === "DEVICE") {
        let foundConstellation;
        let foundCluster;
        let foundDevice;

        for (const property in constellations) {
            const constellation = constellations[property];

            for (let i = 0; i < constellation.cluster.length; i++) {
                const cluster = constellation.cluster[i];

                if (cluster) {
                    const device = cluster.clusterDeviceInfo.find((c) => c.id.value === appView.id.value);

                    if (device) {
                        foundCluster = cluster;
                        foundConstellation = constellation;
                        foundDevice = device;
                        break;
                    }
                }
            }
        }

        if (foundCluster && foundConstellation && foundDevice) {
            device = { cluster: foundCluster, constellation: foundConstellation, device: foundDevice };
        }
    }

    if (appView.type === "USER") {
        user = users[appView.id.value].user;
    }

    if (appView.type === "USER_GROUP") {
        group = userGroups[appView.id.value];
    }

    useMount(() => {
        apiGetConstellations(getGlobalStates().keycloak.token);
        apiGetUserManagement(getGlobalStates().keycloak.token);
        apiGetBackups(getGlobalStates().keycloak.token);
        apiGetDashboards(getGlobalStates().keycloak.token);
    });

    // Start
    useEffect(() => {
        if (appView.type === "CONSTELLATIONS") apiGetConstellations(getGlobalStates().keycloak.token);
        else if (appView.type === "BACKUP_AND_RESTORE") apiGetBackups(getGlobalStates().keycloak.token);
        else if (appView.type === "USER_GROUPS") apiGetUserGroups(getGlobalStates().keycloak.token);
        else if (appView.type === "USER_GROUP") apiGetUserGroup(getGlobalStates().keycloak.token, appView.id);
        else if (appView.type === "USERS") apiGetUsers(getGlobalStates().keycloak.token);
        else if (appView.type === "USER") apiGetUser(getGlobalStates().keycloak.token, appView.id);
    }, [appView]);

    return (
        <>
            {appView.type === "CONSTELLATIONS" && <ConstellationsTable constellations={constellations} />}
            {appView.type === "CONSTELLATION" && constellation && (
                <ClustersTable
                    constellations={constellations}
                    constellation={constellation as IConstellationInfo}
                    permissions={props.permissions}
                    clusterRemoteManagements={clusterRemoteManagements}
                />
            )}
            {appView.type === "BACKUP_AND_RESTORE" && <BackupAndRestoreTable constellations={constellations} />}
            {appView.type === "DEVICE" && device && <DevicePage foundObject={device} />}
            {appView.type === "CLUSTER" && cluster && <ClusterPage foundObject={cluster} />}
            {appView.type === "USERS" && <UsersTable users={users} groups={userGroups} />}
            {appView.type === "USER" && user && <UserPage user={user as KeycloakUser} />}
            {appView.type === "USER_GROUPS" && <UserGroupsTable groups={userGroups} users={users} />}
            {appView.type === "USER_GROUP" && group && <UserGroupPage group={group as UserfulGroup} />}
            <AppStatus />
        </>
    );
}
